import type {
  RFQRequestInputType,
  TcDerivativePosition
} from '@injectivelabs/sdk-ts'

export enum RfqDirection {
  Long = 'long',
  Short = 'short'
}

export type RequestQuotePartialInput = Omit<
  RFQRequestInputType,
  'expiry' | 'status' | 'clientId'
>

export enum TpSlTriggerType {
  MarkPriceGte = 'mark_price_gte',
  MarkPriceLte = 'mark_price_lte'
}

export type TakerIntentState = {
  epoch: number
  laneVersion: number
}

export type ConditionalOrderInput = {
  rfqId: number
  margin: string
  quantity: string
  marketId: string
  direction: string
  worstPrice: string
  triggerPrice: string
  triggerType: TpSlTriggerType
  minTotalFillQuantity: string
}

export type TpSlInput = {
  quantity: string
  triggerPrice: string
}

export type ApplyTpSlInput = {
  tp?: TpSlInput
  sl?: TpSlInput
  slippagePercent?: number
  position: TcDerivativePosition
}
